import { REGION } from '@eureka/utils/environment';
import { DeployEnv } from '@patsnap-utils/biz';

const US_LINKS = [
    'https://eureka.patsnap.com/mse/#/shared/formulation/97ba9954-c63e-4f78-af6d-3a2c985467f3',
    'https://eureka.patsnap.com/mse/#/shared/formulation/6509cdae-a423-47f2-a8cb-058814de0f44',
    'https://eureka.patsnap.com/mse/#/shared/formulation/0b8128c2-8c79-4a71-9cf8-95e245bb300c',
]

const EU_LINKS = [
    'https://eureka.patsnap.eu/mse/#/shared/formulation/ac5c6cdc-ed1e-4784-a3b1-8a7f9c2509ab',
    'https://eureka.patsnap.eu/mse/#/shared/formulation/a9853614-211d-4184-a10e-d2ea7d9a1b64',
    'https://eureka.patsnap.eu/mse/#/shared/formulation/ca9778f4-c10d-4372-b892-3bfddabdc81e',
]


export const getExampleLink = (index: number) => {
    switch (REGION) {
        case DeployEnv.US:
            return US_LINKS[index];
        case DeployEnv.EU:
            return EU_LINKS[index];
        case DeployEnv.CN:
            // TODO: add CN links
        default:
            return US_LINKS[index];
    }
}